/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../../../Common/Style/summaryStyle";
import { dayjsToGermanDate } from "../../../../../services/formatService";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type AlimonyDataProps = {
  formData: AbstractCase | Record<string, any>;
};

const AlimonyData = ({ formData }: AlimonyDataProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Familiäre Situation</Typography>
      </Grid>
      {formData.basicChoice === "complete" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"dateMarriage"} sx={summaryStyle.scrollToAnchor} />
            Datum standesamtliche Heirat
          </Grid>
          <Grid size={12}>
            {dayjsToGermanDate(formData.dateMarriage)}
          </Grid>
        </>
      )}
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"areSeparated"} sx={summaryStyle.scrollToAnchor} />
        Sind Sie getrennt?
      </Grid>
      <Grid size={12}>
        {formData.areSeparated == "yes" ? "Ja" : "Nein"}
      </Grid>
      {formData.areSeparated === "yes" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"dateSeparation"} sx={summaryStyle.scrollToAnchor} />
            Datum der Trennung
          </Grid>
          <Grid size={12}>
            {dayjsToGermanDate(formData.dateSeparation)}
          </Grid>
        </>
      )}
      {formData.basicChoice === "complete" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"areDivorced"} sx={summaryStyle.scrollToAnchor} />
            Sind Sie geschieden?
          </Grid>
          <Grid size={12}>
            {formData.areDivorced === "yes" ? "Ja" : "Nein"}
          </Grid>

          {formData.areDivorced === "yes" && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"dateDivorce"} sx={summaryStyle.scrollToAnchor} />
                Datum der Scheidung
              </Grid>
              <Grid size={12}>
                {dayjsToGermanDate(formData.dateDivorce)}
              </Grid>
            </>
          )}
        </>
      )}
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"numberOfChildren"} sx={summaryStyle.scrollToAnchor} />
        Anzahl aller Kinder
      </Grid>
      <Grid size={12}>
        {formData.numberOfChildren}
      </Grid>
    </>
  );
};

export default AlimonyData;
